import routeNames from "@/router/route-names";

const goBack = ($router, backFrameRoute = null) => {
  //if access from another url then redirect to wallet
  if (backFrameRoute) {
    const url = $router.resolve({ name: backFrameRoute });
    window.parent.location.href = url.href;
  } else {
    history.state ? $router.go(-1) : $router.push({ name: routeNames.WALLET });
  }
};

export { goBack };
